export enum creditCardPrefix {
  amex = 34 | 37,
  masterCard = 50 | 51 | 52 | 53 | 54 | 55,
  visa = 4
}

export enum creditCardType {
  amex = 'Amex',
  masterCard = 'MasterCard',
  visa = 'Visa'
}
